<template>
	<div id="app" style="overflow: auto;">
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>	
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive && RouterState"></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				selected: '',
				RouterState: true,
			};
		},
		provide(){
			return{
				reload: this.reload
			};
		},
		methods:{
			reload(){
				this.RouterState = false;
				this.$nextTick(()=>{
					this.RouterState = true;
				});
			},
		},
		components:{
		},
		created () {
         //this.$router.push('/login'); // 页面加载时跳转
        }
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/App.vue